

const mapAction = (action, payload = {}) => {

    switch (action) {
        case 'OPEN_PRODUCT': {
            const { productId, title } = payload;
            // sample productId: gid://shopify/products/453695275326
            // split the productId to get the id last
            return {
                resource_name: 'products',
                resource_id: productId?.split('/').pop(),
                resource_title: title
            }
        }
        case 'OPEN_COLLECTION': {
            const { collectionId, title } = payload;
            return {
                resource_name: 'collections',
                resource_id: collectionId?.split('/').pop(),
                resource_title: title
            }
        }
        case 'LIST_ORDER': {
            return {
                resource_name: 'orders',
            }
        }
        default: {
            if (action) {
                return {
                    resource_name: action,
                }
            } else {
                return {}
            }

        }
    }

}

export { mapAction };